import { useContext } from 'react';
import { AuthContext } from '../providers/authProvider';
export function useAuth() {
    var _a;
    const [state, dispatch] = useContext(AuthContext);
    const userPermissions = ((_a = state.userData) === null || _a === void 0 ? void 0 : _a.permissions) ? state.userData.permissions : [];
    const hasPermission = (requiredPermission) => userPermissions.includes(requiredPermission);
    return {
        authState: state,
        setAuthState: dispatch,
        hasPermission,
        hasPermissions: (requiredPermissions) => requiredPermissions.some(hasPermission),
        hasNoPermissions: () => userPermissions.length === 0,
    };
}
